<template>
  <div class="filters-popup-wrapper">
		<VButton
			:id="uid"
			theme="link"
			:class="{ active: visible}"
			@click="showPopup"
		>
			<template #icon>
				<VIcon
					material="filter_alt"
					theme="outlined"
				/>
			</template>

			<div :title="titleList.length > 0 ? titleList.join(' | ') : ''">
				<span v-if="titleList.length === 0">
					Фильтры не выбраны
				</span>
				<span
					v-for="(title, index) in titleList"
					:key="'title_' + index"
				>
      		{{ title }}
				</span>
			</div>
			<VIcon material="keyboard_arrow_down" />
		</VButton>

    <VPopup
      class="filters-popup"
      :class="popupExternalClasses"
      :target="'#' + uid"
      :visible="visible"
      :offset="4"
      align="right"
      @update:visible="closePopup"
    >
      <slot />

      <footer>
        <VButton
          theme="primary"
          @click="submitFilters"
        >
          Применить
        </VButton>

        <VButton
          v-if="showClearBtn"
          class="clear-btn"
          @click="clearFilters"
        >
          Сбросить
        </VButton>
      </footer>
    </VPopup>
  </div>
</template>

<style lang="scss" src="./VFiltersPopup.scss"/>

<script>
import uniqueIdMixin from '@/lib/mixins/component-unique-id';

export default {
	name:  'VFiltersPopup',

	mixins: [uniqueIdMixin],

	props: {
		titleList: {
			type:    Array,
			default: () => [],
		},
		showClearBtn: {
			type:    Boolean,
			default: true,
		},
	},

	data() {
		return {
			visible: false,
		};
	},

	computed: {
		popupExternalClasses() {
			return typeof this.$attrs['popup-class'] === 'string'
				? this.$attrs['popup-class'].split(' ')
				: [];
		},
	},

	methods: {
		showPopup() {
			this.visible = true;
		},
		closePopup() {
			this.visible = false;
			this.$emit('close');
		},

		clearFilters() {
			this.$emit('clear');

			/** После нажатия на сброс, должен отправляться запрос */
			this.submitFilters();
		},
		submitFilters() {
			this.$emit('submit');
			this.closePopup();
		},
	},
};
</script>
